import { render, staticRenderFns } from "./rmHomb.vue?vue&type=template&id=5af4b285"
import script from "./rmHomb.vue?vue&type=script&lang=js"
export * from "./rmHomb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports